import Notification, { NOTIFICATION_CONTAINER_SELECTOR, NotificationType } from '../model/notification';

export default class NotificationHelper {
  private static instance: NotificationHelper;
  private readonly notificationContainer: JQuery;

  private constructor() {
    this.notificationContainer = $(NOTIFICATION_CONTAINER_SELECTOR);
    this.bindCloseNotification();
  }

  static get Instance(): NotificationHelper {
    if (!this.instance) {
      this.instance = new NotificationHelper();
    }
    return this.instance;
  }

  getNotificationContainer(): JQuery {
    return this.notificationContainer;
  }

  getNotifications(): JQuery {
    return this.notificationContainer.find('.js-notification');
  }

  getConfirmation(message: string): void {
    this.createNotification(message, NotificationType.Confirmation);
  }

  showConfirmation(message: string): void {
    this.createNotification(message, NotificationType.Confirmation).show();
  }

  createInfo(message: string): void {
    this.createNotification(message, NotificationType.Info);
  }

  showInfo(message: string): void {
    this.createNotification(message, NotificationType.Info).show();
  }

  createError(message: string): void {
    this.createNotification(message, NotificationType.Error);
  }

  showError(message: string): void {
    this.createNotification(message, NotificationType.Error).show();
  }

  clearNotifications(): void {
    this.notificationContainer.find('.js-notification').remove();
  }

  closeNotifications(timeout?: number): void {
    const notifications = this.notificationContainer.find('.js-notification.alert-dismissable');
    const close = () => {
      notifications.each((i, e) => {
        const notification: Notification | null = Notification.getInstance(e);
        if (notification) {
          notification.close();
        }
      });
    };

    if (timeout) {
      setTimeout(close, timeout);
    } else {
      close();
    }
  }

  private createNotification(message: string, type: NotificationType = NotificationType.Confirmation): Notification {
    return new Notification(message, type);
  }

  private bindCloseNotification(): void {
    // Close button for notifications from backend populated by globalMessages.tag
    this.getNotificationContainer().on('click', '.js-closeNotification', (event) => {
      const element = $(event.currentTarget as HTMLElement);
      element.parent('.js-notification').slideUp(200, () => element.parent('.js-notification').remove());
    });
  }
}
